import React, { useEffect } from 'react';
import 'styles/pages/LoadingPage.scss';
import $ from 'jquery';

const LoadingPage = () => {

    useEffect(() => {
        var inputs = $(".progress-ani").find($("label"));

        for (var i = 0; i < inputs.length; i++) {
            var index = i + 1;
            var time = ((inputs.length) + i) * 50;
            $(".progress-ani label:nth-child(" + index + ")").css("-animation", "anim .5s " + time + "ms ease-in-out forwards");
        }
    }, []);

    return (
        <section className='LoadingPage'>
            <div className='LoadingPage-wrapper'>
                <div className='loading-ani'>
                    <div className='scroll-ani'>
                        <div className='progress-ani'>
                            <label>A</label>
                            <label>G</label>
                            <label>I</label>
                            <label>L</label>
                            <label>I</label>
                            <label>N</label>
                            <label>S</label>
                            <label>O</label>
                            <label>F</label>
                            <label>T</label>
                        </div>
                        <div className="progressbar-ani" />
                        <div className='scroll-ani-text'>
                            <div className='scroll-ani-text_item'>
                                SHARING <span>DREAMS</span>
                            </div>
                            <div className='scroll-ani-text_item'>
                                AND
                            </div>
                            <div className='scroll-ani-text_item' >
                                GROWING <span>TOGETHER</span>
                            </div>
                        </div>
                    </div>
                </div >
            </div >
        </section >
    );
};

export default LoadingPage;